import { getTasksWithImpactedTaskOwnersUsingAllocationAndTaskRoleMatch } from './useImpactedTasksByReleasingResources';

export const getImpactedTasksByReleasingAllocations = ({
  resourceUser,
  allocations,
  releaseDate: asOfDate,
  releaseType
}) => {
  if (!allocations.some(allocation => allocation.isSelected))
    return {
      selectedUsersForReleasing: [],
      impactedTasks: []
    };

  const impactedTasks = getTasksWithImpactedTaskOwnersUsingAllocationAndTaskRoleMatch(
    {
      asOfDate,
      releaseType,
      allocations,
      resourceUser
    }
  );

  return {
    selectedUsersForReleasing: impactedTasks.length ? [resourceUser] : [],
    impactedTasks
  };
};
